const TalkWithUs = () => {
  let chatButton
  setTimeout(() => {
    chatButton = document
      .querySelector('iframe[name="Botmaker"]')
      .contentWindow.document.querySelector('#wc-button')
  }, 5000)

  document.querySelector('.btn-open-chat').addEventListener('click', () => {
    chatButton.click()
  })
}

export default TalkWithUs
